import { Box, Typography, Card, Button, IconButton } from "@mui/joy";
import { Plus, Minus } from "lucide-react";

const PackageCard = ({
    pkg,
    isActive,
    isSelected,
    isAddon,
    disableFree,
    selected,
    currentAddons,
    currentExtraAddons,
    isActivePlan
}) => {
    const handleAddAddon = () => {
        currentExtraAddons.increment()
    };

    const handleRemoveAddon = () => {
        if (currentExtraAddons.state >= 0) {
            currentExtraAddons.decrement()
        }
    };

    return (
        <>
            <Card
                key={pkg.stripe_price_id}
                variant="outlined"
                sx={{
                    width: 200,
                    height: 240,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "center",
                    backgroundColor: isActivePlan
                        ? "warning.softBg"
                        : isSelected || isAddon
                        ? "success.softBg"
                        : "background.body",
                    transition: "background-color 0.2s ease-in-out",
                    p: 2,
                }}
            >
                <Box>
                    <Typography level="title-sm" fontWeight="lg">
                        {pkg.label}
                    </Typography>
                    <Typography level="body-md" fontWeight="lg" mt={0.5}>
                        {pkg.price_display}
                    </Typography>
                    <Typography level="body-sm" color="neutral">
                        {pkg._description}
                    </Typography>
                    <Typography level="body-sm" mt={0.5}>
                        {pkg.details}
                    </Typography>
                    {isAddon && (
                        <Typography
                            level="body-sm"
                            mt={0.5}
                            color="primary"
                            fontWeight="lg"
                        >
                            Attivi: {currentAddons.state > 0 ? currentAddons.state : 0} mezzi extra
                        </Typography>
                    )}
                    {pkg.highlight && (
                        <Typography
                            level="body-sm"
                            mt={0.5}
                            fontWeight="lg"
                            color="success.plainColor"
                        >
                            {pkg.highlight}
                        </Typography>
                    )}
                </Box>
                <Box display="flex" justifyContent="center" width="100%" mt={1}>
                    {pkg.is_multiple && isAddon ? (
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <IconButton
                                size="sm"
                                onClick={handleRemoveAddon}
                                disabled={currentExtraAddons.state <= 0}
                            >
                                <Minus size={16} />
                            </IconButton>
                            <Typography width={16} textAlign="center">
                                {currentExtraAddons.state }
                            </Typography>
                            <IconButton
                                size="sm"
                                onClick={handleAddAddon}
                                disabled={isActivePlan}
                            >
                                <Plus size={16} />
                            </IconButton>
                        </Box>
                    ) : (
                        <Button
                            size="sm"
                            fullWidth
                            variant="solid"
                            color={isSelected ? "danger" : "primary"}
                            onClick={() => selected.handle(pkg)}
                            disabled={isActivePlan || (pkg.id === 1 && disableFree)}
                            sx={{ maxWidth: 100 }}
                        >
                            {isActivePlan
                                ? "Attivo"
                                : isSelected
                                ? "Rimuovi"
                                : "Aggiungi"}
                        </Button>
                    )}
                </Box>
            </Card>
        </>
    );
};
export default PackageCard;
